import { render, staticRenderFns } from "./DetailReportTolling.vue?vue&type=template&id=67c9c459&scoped=true&"
import script from "./DetailReportTolling.vue?vue&type=script&lang=js&"
export * from "./DetailReportTolling.vue?vue&type=script&lang=js&"
import style0 from "./DetailReportTolling.vue?vue&type=style&index=0&id=67c9c459&lang=scss&scoped=true&"
import style1 from "./DetailReportTolling.vue?vue&type=style&index=1&id=67c9c459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9c459",
  null
  
)

export default component.exports